import { CLOSE_SHARE_BOX, OPEN_SHARE_BOX } from '../../constants/ShareConstants'

const initialState = {
  active: false,
  url: '',
  imgUrl: '',
  customUrl: '',
  shareType: ''
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_SHARE_BOX: {
      return {
        ...state,
        active: true,
        id: action.id,
        imgUrl: action.imgUrl,
        customUrl: action.customUrl,
        shareType: action.shareType
      }
    }
    case CLOSE_SHARE_BOX: {
      return {
        ...state,
        active: false
      }
    }

    default:
      return state
  }
}
